import ImageObject from './ImageObject';
import BGObject from './BGObject';
import VideoObject from './VideoObject';

export const Display = {
  image: ImageObject,
  video: VideoObject,
  bg: BGObject,
};
